export default __webpack_public_path__ + "static/media/logo138x75white.6adcd4a7.png";